import React from 'react';

class ServiceDisabled extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let topText = "", leftBullets = "", rightBullets = "", indentClass = "styled-indent-blue", btnClass = "btn-info";
    switch(this.props.service) {
    case "seo":
      indentClass = "styled-indent-green";
      btnClass = "btn-success";
      topText = "You aren't currently signed up for SEO, but we can change that!";
      leftBullets = [
        "Increased SEO Revenue 105% in the past year for our clients.",
        "We have clients ranking #3 for \"running shoes \", #1 for \"vaporizers\", #2 for \"jump rope\", #1 for \"christmas ornaments\", and more!",
        "Get the same level of service you've come to expect from the same team. Less agencies to manage!",
        "Staff of veterans with many years of experience who have scaled accounts for reputable brands."
      ];
      rightBullets = [
        "SEO consulting (we'll tell you exactly what to do)",
        "Full service execution (content writing, light development, on-page optimizations)",
        "Keyword tracking & management",
        "Reporting"
      ];
      break;
    case "overall":
      topText = "You aren't currently signed up for PPC, but we can change that!";
      leftBullets = [
        "Increased PPC Revenue 105% in the past year for our clients.",
        "Get the same level of service you've come to expect from the same team. Less agencies to manage!",
        "Staff of veterans with many years of experience who have scaled accounts for reputable brands."
      ];
      rightBullets = [
        "Ads managed primarily through Google Ads and Microsoft Ads",
        "Full service management (structure, bids, ad copy, etc.)",
        "Regular communication",
        "Reporting"
      ];
      break;
    case "search":
      topText = "You aren't currently signed up for paid search, but we can change that!";
      leftBullets = [
        "Increased PPC Revenue 105% in the past year for our clients.",
        "Get the same level of service you've come to expect from the same team. Less agencies to manage!",
        "Staff of veterans with many years of experience who have scaled accounts for reputable brands."
      ];
      rightBullets = [
        "Ads managed through Google Ads and Microsoft Ads",
        "Full service management (structure, bids, ad copy, etc.)",
        "Regular communication",
        "Reporting"
      ];
      break;
    case "social":
      topText = "You aren't currently signed up for paid social, but we can change that!";
      leftBullets = [
        "Increased PPC Revenue 105% in the past year for our clients.",
        "Get the same level of service you've come to expect from the same team. Less agencies to manage!",
        "Staff of veterans with many years of experience who have scaled accounts for reputable brands."
      ];
      rightBullets = [
        "Ads managed through Facebook Ads",
        "Account structure management",
        "Budget & bidding management",
        "Regular communication",
        "Reporting",
        <><b><i>Creative needs to be supplied by client</i></b></>
      ];
      break;
    case "display":
      topText = "You aren't currently signed up for display ads, but we can change that!";
      leftBullets = [
        "Increased PPC Revenue 105% in the past year for our clients.",
        "Get the same level of service you've come to expect from the same team. Less agencies to manage!",
        "Staff of veterans with many years of experience who have scaled accounts for reputable brands."
      ];
      rightBullets = [
        "Ads managed through Google Ads",
        "Account structure management",
        "Budget & bidding management",
        "Regular communication",
        "Reporting",
        "Brand lift studies and a true understanding of value for display",
        <><b><i>Creative needs to be supplied by client</i></b></>
      ];
      break;
    case "video":
      topText = "You aren't currently signed up for video ads, but we can change that!";
      leftBullets = [
        "Increased PPC Revenue 105% in the past year for our clients.",
        "Get the same level of service you've come to expect from the same team. Less agencies to manage!",
        "Staff of veterans with many years of experience who have scaled accounts for reputable brands."
      ];
      rightBullets = [
        "Ads managed through Google Ads (Youtube)",
        "Account structure management",
        "Budget & bidding management",
        "Regular communication",
        "Reporting",
        "Brand lift studies and a true understanding of value for video",
        <><b><i>Creative needs to be supplied by client</i></b></>
      ];
      break;
    }
    if (this.props.organizationName === "Digital Position") {
    if (!this.props.userIsEmployee) {
      return (
        <div className={"row service-disabled " + indentClass}>
          <div className="col-12 pt-1 pl-3">
            <div className="no-gutters clear-both off-color-bg show py-4 px-5">
              <div className="standard-color-bg text-center py-4 px-1">
                <h5>{topText}</h5>
                <p className="pt-2">Reach out to your team and we'll be happy to point you in the right direction!</p>
                <a className={"btn mt-4 " + btnClass} href="/datapulse/my-team">See My Team</a>
              </div>
              <div className="row py-5 px-4">
                <div className="col-6 p-3">
                  <h5>Why sign up?</h5>
                  <ul>
                    {
                      leftBullets.map((bullet, index) => {
                        return(
                          <li key={index}>{bullet}</li>
                        )
                      })
                    }
                  </ul>
                </div>
                <div className="col-6 p-3">
                  <h5>What you'll get:</h5>
                  <ul>
                    {
                      rightBullets.map((bullet, index) => {
                        return(
                          <li key={index}>{bullet}</li>
                        )
                      })
                    }
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    } else {
      let serviceName = "";
      switch(this.props.service) {
      case "seo":
        serviceName = "SEO";
        break;
      case "overall":
        serviceName = "PPC";
        break;
      case "search":
        serviceName = "Search";
        break;
      case "social":
        serviceName = "Social";
        break;
      case "display":
        serviceName = "Display";
        break;
      case "video":
        serviceName = "Video";
        break;
      }
      return (
        <div className={"row service-disabled " + indentClass}>
          <div className="col-12 pt-1 pl-3">
            <div className="no-gutters clear-both off-color-bg show py-4 px-5">
              <div className="standard-color-bg text-center py-4 px-1">
                <h5>This client doesn't have {serviceName} enabled.</h5>
                <p className="pt-2">If you'd like to enable it, please change their configuration settings.</p>
                <a className={"btn mt-4 " + btnClass} href="/datapulse/account-config?page=services">Account Configuration</a>
              </div>
            </div>
          </div>
        </div>
      )
    }
  } else {
    let serviceName = "";
    switch(this.props.service) {
    case "seo":
      serviceName = "SEO";
      break;
    case "overall":
      serviceName = "PPC";
      break;
    case "search":
      serviceName = "Search";
      break;
    case "social":
      serviceName = "Social";
      break;
    case "display":
      serviceName = "Display";
      break;
    case "video":
      serviceName = "Video";
      break;
    }
    return (
      <div className={"row service-disabled " + indentClass}>
          <div className="col-12 pt-1 pl-3">
            <div className="no-gutters clear-both off-color-bg show py-4 px-5">
              <div className="standard-color-bg text-center py-4 px-1">
                <h5>This client doesn't have {serviceName} enabled.</h5>
                <p className="pt-2">If you'd like to enable it, please reach out to your account manager.</p>

              </div>
            </div>
          </div>
        </div>
    )
  }
  }

}

export default ServiceDisabled;
